import splitBillingService from '@/services/splitBillingService';
import { fetchContingencyOptions, getCaseStatusLabel, getMarketingSourceLabel } from '@/services/constants/contingencyOptions';
import { prepareCustomFieldsArray } from '@/services/matterPayloadUtils';
angular.module('leanlaw').controller('MatterViewCtrl', ['$scope', 'leanLawAuth', '$stateParams', '$state', 'alerts', 'matterManager', 'lists', '$http', function ($scope, leanLawAuth, $stateParams, $state, alerts, matterManager, lists, $http) {
  const tabs = [{
    label: 'Info',
    route: `${$scope.module.root}.client.matter.info`
  }, {
    label: 'Overview',
    route: `${$scope.module.root}.client.matter.overview`,
    show: ({
      matter,
      me
    }) => matter && me && me.permissions.matters.overview
  }, {
    label: 'Billing Activity',
    route: `${$scope.module.root}.client.matter.billingActivity`,
    show: ({
      matter,
      me
    }) => matter && me && matter.access.billing && me.permissions.matters.overview && matter.billing.type !== 'internal'
  }, {
    label: 'Billing and Rates',
    route: `${$scope.module.root}.client.matter.access`,
    show: ({
      matter,
      me
    }) => matter && me && matter.access.billing && me.permissions.matters.rates
  }, {
    label: 'Fixed Fees',
    route: `${$scope.module.root}.client.matter.fixed`,
    show: ({
      matter
    }) => matter && matter.access.billing && matter.billing.type !== 'internal' && !matter.isSecondarySplitMatter
  }, {
    label: 'QuickBooks',
    route: `${$scope.module.root}.client.matter.billing`,
    show: ({
      matter,
      me
    }) => matter && me && matter.access.billing && matter.billing.type !== 'internal' && me.permissions.matters.rates
  }, {
    label: 'LEDES',
    route: `${$scope.module.root}.client.matter.ledes`,
    show: ({
      matter,
      me
    }) => matter && (!me.features.ledesXml2 && matter && me && matter.access.billing && matter.billing.type !== 'internal' && me.company.settings.codes.ledes || me.features.ledesXml2 && matter.client && matter.client.codes && matter.client.codes.ledes)
  }, {
    label: 'NetDocuments',
    route: `${$scope.module.root}.client.matter.netdocs`,
    show: ({
      me
    }) => me && me.features.netdocs && me.company.settings.documents && me.company.settings.documents.cabinetId
  }, {
    label: 'Split Billing',
    route: `${$scope.module.root}.client.matter.splitBilling`
  }, {
    label: 'Liens',
    route: `${$scope.module.root}.client.matter.liens`,
    show: ({
      matter,
      me
    }) => matter && me && me.features.settlementTab && matter.billing.type === 'contingency'
  }, {
    label: 'Settlement',
    route: `${$scope.module.root}.client.matter.settlement`,
    // Always show the tab if the matter is contingency and the feature flag is on
    show: ({
      matter,
      me
    }) => matter && me && matter.billing.type === 'contingency' && me.features.settlementTab
  }, {
    label: 'Fee Recipients',
    route: `${$scope.module.root}.client.matter.feeRecipients`,
    show: ({
      matter,
      me
    }) => matter && me && me.features.coCounsel && me.features.settlementRedesign && matter.billing.type === 'contingency'
  }];
  $scope.vm = {
    tabs,
    isEditing: false,
    saving: false,
    customFields: [],
    loading: false,
    enable: {
      delete: false,
      archive: false,
      activate: false
    }
  };
  $scope.save = save;
  $scope.cancel = cancel;
  $scope.startEditing = startEditing;
  $scope.delete = deleteMatter;
  $scope.restore = () => changeMatterStatus(true);
  $scope.archive = () => changeMatterStatus(false);
  $scope.role = lists.userRoleFromId;
  $scope.domain = `${leanLawAuth.domain}/v1`;

  // Contingency field helpers using shared constants
  $scope.module.getCaseStatusLabel = getCaseStatusLabel;
  $scope.module.getMarketingSourceLabel = getMarketingSourceLabel;

  // callback from modules/matters controllers when matter change
  $scope.assignMatterToScope = function (matter) {
    $scope.matter = matter;
    $scope.module.matter = matter;
    if ($scope.matter.isSecondarySplitMatter) {
      splitBillingService.getPrimaryMatter($scope.matter.id).then(primary => {
        if (primary && primary.client) {
          $scope.matter.primaryMatterClientName = primary.client.name;
          $scope.matter.primaryMatterName = primary.name;
          $scope.matter.primaryMatterId = primary.matterId || primary.id;
          $scope.matter.primaryMatterClientId = primary.client.clientId || primary.client.id;
        }
      });
    }
  };
  activate();
  async function activate() {
    const {
      matterId
    } = $stateParams;
    $scope.vm.loading = true;
    $scope.module.matter = await matterManager.get(matterId);
    $scope.vm.loading = false;

    // Preload contingency options for label lookup (cached, non-blocking)
    if ($scope.module.matter.billing?.type === 'contingency') {
      fetchContingencyOptions().then(() => $scope.$applyAsync()).catch(error => {
        console.error('Failed to load contingency options:', error);
        alerts.error('Failed to load contingency field options. Please refresh the page.');
      });
    }
    if ($scope.module.matter.isSecondarySplitMatter) {
      const primary = await splitBillingService.getPrimaryMatter($scope.module.matter.id);
      if (primary && primary.client) {
        $scope.module.matter.primaryMatterClientName = primary.client.name;
        $scope.module.matter.primaryMatterName = primary.name;
        $scope.module.matter.primaryMatterId = primary.matterId || primary.id;
        $scope.module.matter.primaryMatterClientId = primary.client.clientId || primary.client.id;
      }
    }

    // required for tab content using controllers/views from modules/matters
    // (can be cleaned up when old matters page is deprecated and controllers from there moved here)
    $scope.matter = $scope.module.matter;
    $scope.data = {
      users: $scope.module.users
    };

    // Determines if archive/delete buttons are shown
    const stats = await $scope.matter.stats();
    $scope.vm.enable = {
      delete: stats.deletable,
      archive: $scope.module.matter.active,
      activate: !$scope.module.matter.active,
      editMatterInfo: !$scope.module.matter.isSecondarySplitMatter
    };
    loadMattersCustomFields();
  }
  function loadMattersCustomFields() {
    const path = `${$scope.domain}/matters/${$stateParams.matterId}/customfields`;
    $http.get(path).then(response => {
      if (response.data) {
        $scope.module.customFields = response.data.customFields.map(customField => ({
          id: customField.customField.id,
          value: customField.value,
          type: customField.customField.type,
          label: customField.customField.name,
          textValue: customField.textValue,
          numberValue: customField.numberValue,
          enumValueId: customField.enumValue?.id,
          enumOptions: customField.customField.enumOptions || []
        }));
        $scope.module.customFields = angular.copy($scope.module.customFields);
      }
    });
  }
  function deleteMatter() {
    const term = $scope.module.me.terms.matter;
    bootbox.confirm(`<h4>Do you want to delete this ${term}?</h4><p>There is no activity (time entries, invoices etc) recorded for the ${term} but note that you can't undo it.`, result => {
      if (result) {
        $scope.vm.saving = true;
        $scope.module.matter.delete().then(() => {
          alerts.success(`The ${term} was deleted`);
          // go to top level route (client/matters-next)
          $state.go($state.current.name.split('.')[0]);
        }).catch(err => {
          $scope.vm.saving = false;
          alerts.error(err);
        });
      }
    });
  }
  function changeMatterStatus(active) {
    const term = $scope.module.me.terms.matter;

    // Check if this is a secondary split billing matter and restrict both archive and restore
    if ($scope.module.matter.isSecondarySplitMatter) {
      const action = active ? 'Restore' : 'Archive';
      splitBillingService.showActionRestrictionIfNeeded($scope.module.matter.id, term, action);
      return;
    }
    if (!active) {
      let message = `<h4>Do you want to archive this ${term}?</h4><p>Archiving the ${term} will hide it from all users and hide any unbilled time or expenses from some pages. You can easily restore the ${term} from here if you need it again.</p>`;
      bootbox.confirm(message, result => {
        if (result) {
          change(false, `The ${term} was archived. You can find it on the lists by selecting 'Show Archived'.`);
        }
      });
    } else {
      change(true, `The ${term} was restored.`);
    }
  }
  function change(status, confirmation) {
    $scope.vm.saving = true;
    return $scope.module.matter.activate(status).then(matter => {
      alerts.success(confirmation);
      $scope.vm.enable.activate = !status;
      $scope.vm.enable.archive = status;
      return $scope.assignMatterToScope(matter);
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.vm.saving = false;
    });
  }
  function startEditing() {
    $scope.vm.customFields = angular.copy($scope.module.customFields || []);
    $scope.vm.originalMatter = angular.copy($scope.module.matter);
    $scope.vm.isEditing = true;
  }
  $scope.$on('originationStepDownChanged', (event, data) => {
    $scope.originationStepDownChanged = data;
  });
  async function save() {
    if (!$scope.originationStepDownChanged && $scope.module.me.company.settings.report?.originationStepDownPeriodInMonths) {
      delete $scope.module.matter.billing['originationStepDownStatus'];
      delete $scope.module.matter.billing['originationStepDownDisabled'];
      delete $scope.module.matter.billing['originationStepDownPeriodInMonths'];
      delete $scope.module.matter.billing['originationStepDownStart'];
    }
    $scope.vm.saving = true;
    try {
      if ($scope.vm.customFields.length) {
        const path = `${$scope.domain}/matters/${$stateParams.matterId}/customfields`;
        // Use prepareCustomFieldsArray to handle clearing values correctly
        const payload = {
          customFields: prepareCustomFieldsArray($scope.vm.customFields)
        };
        await $http.put(path, payload);
      }
      await $scope.module.matter.update();
      await loadMattersCustomFields();
      $scope.vm.isEditing = false;
    } catch (err) {
      alerts.error(err);
    } finally {
      $scope.vm.saving = false;
      $scope.$emit('matterBillingIsDirty', false);
      $scope.$emit('originationStepDownChanged', false);
    }
  }
  function cancel() {
    $scope.vm.customFields = angular.copy($scope.module.customFields);
    // Restore matter to original state before editing
    if ($scope.vm.originalMatter) {
      Object.assign($scope.module.matter, $scope.vm.originalMatter);
      $scope.matter = $scope.module.matter;
    }
    $scope.vm.isEditing = false;
    $scope.$emit('matterBillingIsDirty', false);
    $scope.$emit('originationStepDownChanged', false);
  }
}]);